function hasAuth0Config() {
  return Boolean(
    process.env.REACT_APP_AUTH0_DOMAIN &&
    process.env.REACT_APP_AUTH0_CLIENT_ID
  );
}

export function shouldUseAuth0() {
  if (typeof window !== 'undefined' && window.Cypress) {
    return false;
  }

  return hasAuth0Config();
}
